import request from '@/utils/request'

export function stage (query) {
  return request({
    url: '/api/stage',
    method: 'get',
    params: query
  })
}

export function donateStatistics () {
  return request({
    url: '/api/donate/statistics',
    method: 'get'
  })
}

export function activities () {
  return request({
    url: '/api/stage/activities',
    method: 'get'
  })
}

export function activity (id) {
  return request({
    url: '/api/stage/activity/' + id,
    method: 'get'
  })
}

export function search (query) {
  return request({
    url: '/api/donate/search',
    method: 'get',
    params: query
  })
}

export function certificate (query) {
  return request({
    url: '/api/certificate/search',
    method: 'get',
    params: query
  })
}

export function interflow (donateId) {
  return request({
    url: '/api/donate/detail/' + donateId,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js